import { Routes, Route } from 'react-router-dom';
import TxInput from './components/TxInput';
import SuggestedTransactions from './components/SuggestedTransactions';
import TxDetailPage from './components/TxDetailPage';

export default function App() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      {/* Header */}
      <header className="border-b border-slate-800 bg-slate-900/50 backdrop-blur">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <a href="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-cyan-500 flex items-center justify-center text-white font-bold text-sm">
              SV
            </div>
            <h1 className="text-lg font-semibold tracking-tight">
              Solana TX Visualizer
            </h1>
          </a>
          <div className="text-xs text-slate-500">
            CPI Tree · CU Timeline · Account Diffs
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-6 space-y-6">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tx/:signature" element={<TxDetailPage />} />
        </Routes>
      </main>
    </div>
  );
}

function HomePage() {
  return (
    <div className="space-y-6">
      <TxInput />
      <SuggestedTransactions />
    </div>
  );
}
